/**
 * Client list thumbs matrix: avatar fills, column-count slider, mobile flyout.
 */

import { generateAvatarCircleFill, applyAvatarPhoto } from './redfish';

function current_client_avatar_style() {
  const select = document.querySelector('.js-client-avatar-style');
  if (select && select.value) return select.value;
  const avatar = document.querySelector('.js-client-matrix-avatar[data-avatar-style], .js-client-form-avatar[data-avatar-style]');
  if (avatar) return avatar.getAttribute('data-avatar-style');
  return 'soft_radial';
}

function current_employee_avatar_style() {
  const select = document.querySelector('.js-employee-avatar-style');
  if (select && select.value) return select.value;
  const avatar = document.querySelector('.js-employee-matrix-avatar[data-avatar-style], .js-employee-form-avatar[data-avatar-style], .user_avatar_circle[data-avatar-style]');
  if (avatar) return avatar.getAttribute('data-avatar-style');
  return 'soft_radial';
}

function fill_avatar_element(el, style, kind) {
  const image_url = el.getAttribute('data-avatar-url');
  if (image_url) {
    applyAvatarPhoto(el, image_url);
    el.setAttribute('data-avatar-filled', 'true');
    return;
  }
  el.setAttribute('data-avatar-style', style);
  el.setAttribute('data-avatar-kind', kind);
  generateAvatarCircleFill(el.getAttribute('data-nachname') || '', el.getAttribute('data-vorname') || '', el, style, kind);
  el.setAttribute('data-avatar-filled', 'true');
}

export function fillPersonClientMatrixAvatars(options) {
  const skip_close = options && options.skip_close;
  if (!skip_close) close_matrix_flyout();
  const client_style = current_client_avatar_style();
  document.querySelectorAll('.js-client-matrix-avatar').forEach((el) => {
    if (skip_close && el.getAttribute('data-avatar-filled') === 'true') return;
    fill_avatar_element(el, client_style, 'client');
  });
  const employee_style = current_employee_avatar_style();
  document.querySelectorAll('.js-employee-matrix-avatar').forEach((el) => {
    if (skip_close && el.getAttribute('data-avatar-filled') === 'true') return;
    fill_avatar_element(el, employee_style, 'employee');
  });
}

function apply_matrix_size(cols) {
  const grid = document.querySelector('.person-client-matrix');
  if (!grid) return;
  const min = parseInt(grid.getAttribute('data-matrix-min') || '4', 10);
  const max = parseInt(grid.getAttribute('data-matrix-max') || '12', 10);
  let n = parseInt(cols, 10);
  if (Number.isNaN(n)) n = 6;
  if (n < min) n = min;
  if (n > max) n = max;
  grid.style.setProperty('--matrix-cols', String(n));
}

function apply_client_avatar_style(style) {
  if (!style) return;
  document.querySelectorAll('.js-client-matrix-avatar, .js-client-form-avatar').forEach((el) => {
    el.setAttribute('data-avatar-style', style);
    el.removeAttribute('data-avatar-filled');
  });
  fillPersonClientMatrixAvatars();
  document.querySelectorAll('.js-client-form-avatar').forEach((el) => {
    const nachname = document.getElementById('client_nachname');
    const vorname = document.getElementById('client_vorname');
    generateAvatarCircleFill(
      nachname ? nachname.value : '',
      vorname ? vorname.value : '',
      el,
      style
    );
  });
}

function apply_employee_avatar_style(style) {
  if (!style) return;
  document.querySelectorAll('.js-employee-matrix-avatar, .js-employee-form-avatar, .user_avatar_circle').forEach((el) => {
    el.setAttribute('data-avatar-style', style);
    el.removeAttribute('data-avatar-filled');
  });
  fillPersonClientMatrixAvatars();
  const nachname = document.getElementById('employee_nachname');
  const vorname = document.getElementById('employee_vorname');
  document.querySelectorAll('.js-employee-form-avatar').forEach((el) => {
    if (el.classList.contains('is-photo') && el.getAttribute('data-avatar-url')) return;
    generateAvatarCircleFill(
      nachname ? nachname.value : '',
      vorname ? vorname.value : '',
      el,
      style,
      'employee'
    );
  });
  document.querySelectorAll('.user_avatar_circle').forEach((el) => {
    if (el.classList.contains('is-photo') && el.getAttribute('data-avatar-url')) return;
    generateAvatarCircleFill(
      el.getAttribute('data-nachname') || '',
      el.getAttribute('data-vorname') || '',
      el,
      style,
      'employee'
    );
  });
}

function prefers_matrix_flyout() {
  return window.matchMedia('(max-width: 40em), (hover: none) and (pointer: coarse)').matches;
}

function ensure_matrix_backdrop() {
  let backdrop = document.querySelector('.person-client-matrix-backdrop');
  if (backdrop) return backdrop;
  backdrop = document.createElement('div');
  backdrop.className = 'person-client-matrix-backdrop';
  document.body.appendChild(backdrop);
  return backdrop;
}

function close_matrix_flyout() {
  const flyout = document.querySelector('.person-client-matrix-flyout.is-open');
  if (!flyout) return;
  const placeholder = flyout.matrixPlaceholder;
  flyout.classList.remove('is-open');
  flyout.matrixPlaceholder = null;
  flyout.matrixCell = null;
  if (placeholder && placeholder.parentNode) {
    placeholder.parentNode.replaceChild(flyout, placeholder);
  } else if (flyout.parentNode === document.body) {
    flyout.parentNode.removeChild(flyout);
  }
  document.body.classList.remove('person-client-matrix-flyout-active');
}

function open_matrix_flyout(cell) {
  const flyout = cell.querySelector('.person-client-matrix-flyout');
  if (!flyout) return;
  close_matrix_flyout();
  const placeholder = document.createElement('div');
  placeholder.className = 'person-client-matrix-flyout-placeholder';
  placeholder.style.height = `${cell.offsetHeight}px`;
  flyout.matrixCell = cell;
  flyout.matrixPlaceholder = placeholder;
  cell.insertBefore(placeholder, flyout);
  document.body.appendChild(flyout);
  flyout.classList.add('is-open');
  document.body.classList.add('person-client-matrix-flyout-active');
  ensure_matrix_backdrop();
}

function on_matrix_document_click(event) {
  const target = event.target;
  if (!target || !target.closest) return;

  const open_flyout = document.querySelector('.person-client-matrix-flyout.is-open');
  if (!open_flyout && !document.querySelector('.person-client-matrix')) return;

  if (target.closest('.person-client-matrix-backdrop')) {
    close_matrix_flyout();
    return;
  }

  if (open_flyout && open_flyout.contains(target)) return;

  const flyout_opener = target.closest('.person-client-matrix-avatar-link, .person-client-matrix-name');
  if (flyout_opener && prefers_matrix_flyout()) {
    const cell = flyout_opener.closest('.person-client-matrix-cell');
    const flyout = cell && cell.querySelector('.person-client-matrix-flyout');
    if (flyout && flyout.classList.contains('is-open')) return;
    event.preventDefault();
    event.stopPropagation();
    if (cell) open_matrix_flyout(cell);
    return;
  }

  if (open_flyout) close_matrix_flyout();
}

export function initPersonClientMatrix() {
  if (document.documentElement.dataset.personClientMatrixReady === 'true') return;
  document.documentElement.dataset.personClientMatrixReady = 'true';

  document.addEventListener('input', (event) => {
    const input = event.target && event.target.closest && event.target.closest('.js-clients-list-matrix-size, .js-employees-list-matrix-size');
    if (!input) return;
    apply_matrix_size(input.value);
  });

  document.addEventListener('change', (event) => {
    const client_size_input = event.target && event.target.closest && event.target.closest('.js-clients-list-matrix-size');
    if (client_size_input) {
      apply_matrix_size(client_size_input.value);
      if (typeof window.ajax_set_session_pref === 'function') {
        window.ajax_set_session_pref('clients_list_matrix_size', client_size_input.value);
      }
      return;
    }

    const employee_size_input = event.target && event.target.closest && event.target.closest('.js-employees-list-matrix-size');
    if (employee_size_input) {
      apply_matrix_size(employee_size_input.value);
      if (typeof window.ajax_set_session_pref === 'function') {
        window.ajax_set_session_pref('employees_list_matrix_size', employee_size_input.value);
      }
      return;
    }

    const client_style_select = event.target && event.target.closest && event.target.closest('.js-client-avatar-style');
    if (client_style_select) {
      apply_client_avatar_style(client_style_select.value);
      if (typeof window.ajax_set_session_pref === 'function') {
        window.ajax_set_session_pref('client_avatar_style', client_style_select.value);
      }
      return;
    }

    const employee_style_select = event.target && event.target.closest && event.target.closest('.js-employee-avatar-style');
    if (!employee_style_select) return;
    apply_employee_avatar_style(employee_style_select.value);
    if (typeof window.ajax_set_session_pref === 'function') {
      window.ajax_set_session_pref('employee_avatar_style', employee_style_select.value);
    }
  });

  document.addEventListener('click', on_matrix_document_click, true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close_matrix_flyout();
  });

  fillPersonClientMatrixAvatars();
}
